import { useMutation } from '@tanstack/react-query';

import { participantProjectsControllerStartUnmoderatedProject } from '@/api/core-api/sdk.gen';
import { getClient } from '@/utils/get-api-client';

export function useStartUnmoderatedProject() {
  return useMutation({
    mutationFn: async ({
      projectId,
      userId,
    }: {
      projectId: string;
      userId: string;
    }) => {
      const client = getClient(userId);
      const response =
        await participantProjectsControllerStartUnmoderatedProject({
          client,
          path: {
            id: projectId,
          },
        });

      if (response.error || !response.data?.surveyUrl) {
        throw new Error('Failed to start project');
      }

      return response.data;
    },
  });
}
